import React from 'react';
import ErrorPage from './ErrorPage';
import AuthContext from '../../../context/auth/AuthContext';
import axios from 'axios';

function isSessionStorageAvailable() {
  // Check if sessionStorage is available in the current browser.
  try {
    // try to use sessionStorage to assert it's available
    const stub = 'stub';
    sessionStorage.setItem(stub, stub);
    sessionStorage.removeItem(stub);
    return true;
  } catch (e) {
    // not available
    return false;
  }
}

class ErrorCatcher extends React.Component {
  // Error boundary component for catching JavaScript errors anywhere in the child component tree.
  constructor(props) {
    super(props);
    this.loadId = new Date().toLocaleDateString(); // Unique identifier for each page load (today)
    this.state = { hasError: false, errorType: null };
    if (isSessionStorageAvailable()) {
      sessionStorage.setItem('loadId', this.loadId);
    }
  }

  static getDerivedStateFromError(error) {
    let hasReloaded = true; // default to true to prevent infinite loop
    if (isSessionStorageAvailable()) {
      const loadId = sessionStorage.getItem('loadId');
      hasReloaded = sessionStorage.getItem('hasReloaded') === loadId;
    }
    return { hasError: true, errorType: error.name, hasReloaded };
  }

  componentDidCatch(error, info) {
    if (error.name === 'ChunkLoadError') {
      if (this.state.hasReloaded === false) {
        // Only attempt to reload once -- hasRealoaded can only be false if sessionStorage is available
        // inform of recovery, can be removed in the future once we assert all is working as intended
        this.logError('ChunkLoadError - Recovered Session', info);
        sessionStorage.setItem('hasReloaded', this.loadId);
        window.location.reload();
      } else {
        // no sessionStorage available, must let user handle error manually
        this.logError(
          "ChunkLoadError - Can't Recovered Session (No storage session available)",
          info
        );
      }
    } else {
      // Log the error
      this.logError(error, info);
    }
  }

  logError(error, info) {
    axios
      .post('/log_error', {
        userInfo: this.context?.userInfo || {},
        error: error.toString ? error.toString() : `${error}`,
        errorStack: error.stack ? error.stack.toString() : '',
      })
      .then((response) => {
        console.log('res', response);
      })
      .catch((error) => {
        console.log('error', error);
      });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    } else {
      return this.props.children;
    }
  }
}

ErrorCatcher.contextType = AuthContext;

export default ErrorCatcher;
